import { simulateContract, writeContract } from '@wagmi/core';

import { Address } from 'viem';

import { LAUNCHPAD_SALE_POOL_TYPE, LaunchpadSalePoolType } from '@api';

import { wagmiConfig } from '@shared/common/providers/Web3Provider/wagmi';
import {
  DEFAULT_TARGET_CHAIN,
  LAUNCHPAD_DEPOSIT_CONTRACT,
  LAUNCHPAD_PRO_RATA_CONTRACT,
} from '@shared/constants';

export const isProRataType = (type?: LaunchpadSalePoolType) => {
  if (!type) {
    return false;
  }

  return (
    type === LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA ||
    type === LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA_SQRP_GATED
  );
};

const depositContractCall = async ({
  props,
  type,
}: {
  type: LaunchpadSalePoolType;
  props: {
    amount: number;
    contractAddress: Address;
    amountInWei: string;
    userId: string;
    transactionId: string;
    exchangeRateInWei: string;
    walletAddress: Address;
    timeStampLimit: number;
    signature: Address;
    boosted: boolean;
  };
}) => {
  const {
    contractAddress,
    amountInWei,
    userId,
    transactionId,
    walletAddress,
    timeStampLimit,
    signature,
    exchangeRateInWei,
    boosted,
  } = props;

  if (isProRataType(type)) {
    const { request } = await simulateContract(wagmiConfig, {
      ...LAUNCHPAD_PRO_RATA_CONTRACT,
      address: contractAddress,
      functionName: 'depositSig',
      chainId: DEFAULT_TARGET_CHAIN.id,
      gas: BigInt(500_000),
      args: [
        {
          baseAmount: BigInt(amountInWei),
          boost: boosted,
          boostExchangeRate: BigInt(exchangeRateInWei),
          transactionId,
          timestampLimit: timeStampLimit,
          signature,
        },
      ],
    });

    return writeContract(wagmiConfig, request);
  }

  const { request } = await simulateContract(wagmiConfig, {
    ...LAUNCHPAD_DEPOSIT_CONTRACT,
    address: contractAddress,
    functionName: 'depositSig',
    chainId: DEFAULT_TARGET_CHAIN.id,
    gas: BigInt(500_000),
    args: [userId, transactionId, walletAddress, BigInt(amountInWei), timeStampLimit, signature],
  });

  return writeContract(wagmiConfig, request);
};

export default depositContractCall;
